export default __webpack_public_path__ + "static/media/pve1.6c423f54.jpg";